// --
import React from 'react';
import {Icon, utils} from 'mc/lib';
import {Alert} from "reactstrap";

// Id ověření v případě, že uživatel stiskl ověřit a z registrů se nic nedohledalo - je neztotožněn
export const OVERENI_ID_NONE = -23675;

/**
 * Komponenta pro zobrazení informace o dohledání (ověření) subjektu vůči registrům.
 */
export default class SubjektOvereniInfo extends React.Component {
    static PropTypes = {
        subjekt: React.PropTypes.object.isRequired,  // subjekt
    };

    render() {
        const {className, vazbaZr, subjekt, roleConf, overeniIdInt} = this.props;

        let overeniInfo = [];
        let color;
        if (vazbaZr || roleConf.ares) {
            if (overeniIdInt != null) {
                if (overeniIdInt === OVERENI_ID_NONE) {    // pokus o dohledání, ale nebyl dohledán - je neztotožněn
                    color = "warning";
                    overeniInfo.push(<div><Icon icon="exclamation-triangle"/> {roleConf.ares ? "Neztotožněn" : "Neztotožněn vůči základním registrům"}</div>);
                } else {
                    color = "success";
                    overeniInfo.push(<div><Icon icon="check"/> {roleConf.zr ? "Ověřen v základních registrech" : "Dohledán v ARES"}</div>);
                }
            } else {
                color = "danger";
                if (roleConf.zr) {
                    overeniInfo.push(<div><Icon icon="remove"/> Neověřen v základních registrech</div>);
                }
            }
        } else {
            color = "info";
            if (roleConf.zr) {
                overeniInfo.push(<div><Icon icon="chain"/> Bez vazby na základní registry</div>);
            }
        }

        if (overeniInfo.length > 0) {
            return <Alert className={className} color={color}>{overeniInfo}</Alert>;
        } else {
            return <span></span>;
        }
    }
}
